import React from 'react';
import { Section } from '../Section';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { WELD_BEAD_IMAGE } from '../../data/content';
export function AlwaysWithYou() {
  return <Section tone="panel" data-id="element-62" data-mp="19xpzrv3afs0k">
      <div className="overflow-hidden rounded-2xl border border-white/10 bg-ink-800" data-id="element-63" data-mp="19yhs8x1l99mm">
        <img src={WELD_BEAD_IMAGE} alt="Close-up of a clean, consistent weld bead on steel" className="h-40 w-full object-cover sm:h-56" width={1600} height={900} data-id="element-64" data-mp="1ewaw3jff5rjq" />
        <div className="p-5 sm:p-8" data-id="element-65" data-mp="27icehso82ple">
          <h2 className="font-display text-[26px] font-bold uppercase leading-[1.08] text-white sm:text-4xl" data-id="element-66" data-mp="1tl76hn4y7gni">
            Your welding reference guide is always with you
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-white/70 sm:text-base" data-id="element-67" data-mp="i5qs4bgsb0s3">
            Instead of watching another 20-minute video every time you have a
            question, simply open the corresponding manual, find the problem and
            get back to work.
          </p>
          <p className="mt-4 text-base font-bold uppercase leading-snug text-teal-bright" data-id="element-68" data-mp="2byq7wwzgtm6k">
            One system. Six Master Manuals. Hundreds of practical solutions.
          </p>

          <div className="mx-auto mt-7 w-full max-w-xl" data-id="element-69" data-mp="2pweuqad3f3e9">
            <CtaButton label="I want the Master Welding System" data-id="element-70" data-mp="2lvutaulhldmb" />
            <Countdown className="mt-6" data-id="element-71" data-mp="2zwfge2yfpvlm" />
            <p className="mt-4 text-center text-[11px] font-medium uppercase tracking-wider text-white/45 sm:text-xs" data-id="element-72" data-mp="2zve11madymy3">
              One-time payment · Instant access · Lifetime access · 7-day
              guarantee
            </p>
          </div>
        </div>
      </div>
    </Section>;
}